/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_NameInputs */

const en_us2_profile_row_name = /** @type {(inputs: Profile_Row_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const pt_br2_profile_row_name = /** @type {(inputs: Profile_Row_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const es_419_profile_row_name = /** @type {(inputs: Profile_Row_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const pt_pt2_profile_row_name = /** @type {(inputs: Profile_Row_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const fr_fr2_profile_row_name = /** @type {(inputs: Profile_Row_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const de_de2_profile_row_name = /** @type {(inputs: Profile_Row_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const it_it2_profile_row_name = /** @type {(inputs: Profile_Row_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Profile_Row_NameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_name = /** @type {((inputs?: Profile_Row_NameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_NameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_name(inputs)
	if (locale === "es-419") return es_419_profile_row_name(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_name(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_name(inputs)
	if (locale === "de-DE") return de_de2_profile_row_name(inputs)
	if (locale === "it-IT") return it_it2_profile_row_name(inputs)
	return en_us2_profile_row_name(inputs)
});
export { profile_row_name as "profile.row_name" }